<template>
  <div id="home">
    <!-- NavBar.vue -->
    <nav-bar>
      <!-- 插槽模板 -->
      <template v-slot:default>
        <div>
          <div style="margin-top: -4px;font-weight:bold">
            Booking书店
          </div>
          <div style="margin-top: -26px;">
            books.ddxk.cn
          </div>
        </div>
      </template>

    </nav-bar>
    <!-- <tab-control
      v-show="isTabFixed"
      @tabClick="tabClick"
      :titles="['畅销','新书','精选']"
    ></tab-control> -->
    <div class="wrapper">
      <div
        class="content"
        style=""
      >
        <!-- 轮播图 -->
        <!--            <home-swiper :banners="banners"></home-swiper>-->
        <!-- 推荐 -->
        <!-- <div ref="banref">
      
          <recommend-view :recommends="recommends"></recommend-view>
        </div> -->
        <div class="recommend">
          <div
            class="recommend-item"
            v-for="item in recommends"
            :key="item.id"
            style="margin-bottom: 20px;"
            @click="goD()"
          >

            <!-- <img src="~assets/images/01.jpg" alt=""> -->
            <img
              v-lazy="item.url||'~assets/images/01.jpg'"
              alt=""
              style="background:#dddddd80"
            >
            <div style="width:80%;margin:auto;font-size: 1rem;background:#dddddd33;margin-top:-2px;padding:6px 4px">
              <div
                style="text-align:left"
                class="text-ellipsis"
              >{{item.name}}</div>
              <div style="display: flex;margin-top:4px">
                <div>
                  价格:￥{{ item.price }}
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- @tabClick="tabClick"自定义事件 -->
        <!-- <tab-control
          @tabClick="tabClick"
          :titles="['畅销','新书','精选']"
        ></tab-control>
        <goods-list :goods="showGoods"></goods-list> -->

      </div>

    </div>

  </div>
</template>

<script>
// 轮播图
import NavBar from 'components/common/navbar/NavBar'
// 导航栏
import RecommendView from './ChildComps/RecommendView'
// 
import TabControl from 'components/content/tabControl/TabControl'
// 商品列表
import GoodsList from 'components/content/goods/GoodsList'
import { ref, onMounted, reactive, computed, watchEffect, nextTick } from 'vue';
import { getHomeAllData, getHomeGoods } from 'network/home';
// 滚动插件
import BScroll from 'better-scroll'
// 返回顶部
import BackTop from 'components/common/backtop/BackTop'
// 
import HomeSwiper from './ChildComps/HomeSwiper'
import { Toast } from 'vant';

// 挂载--生命周期
export default {
  name: 'Home',
  components: {
    HomeSwiper,
    NavBar,
    RecommendView,
    TabControl,
    GoodsList,
    BackTop
  },
  setup () {
    //   临时变量
    let temid = ref(0);
    let banref = ref(null);
    const recommends = ref([]);
    let isTabFixed = ref(false);
    // 返回顶部
    let isShowBackTop = ref(false);
    //商品列表数据模型
    const goods = reactive({
      sales: { page: 1, list: [] },
      new: { page: 1, list: [] },
      recommend: { page: 1, list: [] }
    })

    let currentType = ref('sales');

    const showGoods = computed(() => {
      return goods[currentType.value].list;
    })
    let bscroll = reactive({});
    let banners = ref([]);
    onMounted(() => {
      // 获取首页推荐的数据
      // getHomeAllData().then(res => {
      //   recommends.value = res.goods.data;
      //   banners.value = res.slides;
      //   // console.log(res.slides);
      // })
      recommends.value = [
        { "no": "9787508286457", "name": "【绘本】我最爱的儿童歌曲0-3岁", "price": 21, "url": "https://img3m1.ddimg.cn/83/26/23422691-1_w_1.jpg" },
        { "no": "9787558131554", "name": "【引进版·绘本】世界经典童话：海的女儿", "price": 19.8, "url": "https://img3m6.ddimg.cn/23/10/1803063956-1_b_1.jpg" },
        { "no": "9787516909263", "name": "国学经典精粹丛书：易经", "price": 36, "url": "https://img3m2.ddimg.cn/14/30/11251868972-1_b_1716773897.jpg" },
        { "no": "9787547017814", "name": "神奇世界全知道：神秘宇宙、地球密码（彩色注音版）", "price": 29.8, "url": "https://img3m8.ddimg.cn/53/0/11763569618-1_b_1720428369.jpg" },
        { "no": "9787502839321", "name": "冰心儿童图书奖获奖作品--那个寒夜很温暖", "price": 28, "url": "https://img3m4.ddimg.cn/60/3/11855982264-1_b_1731139206.jpg" },
        { "no": "9787304073596", "name": "喜羊羊与灰太狼儿童巧手立体纸工书：宇宙飞船", "price": 23.8, "url": "https://img3m1.ddimg.cn/14/19/11914436471-1_b_1732251920.jpg" },
        { "no": "9787514026696", "name": "三分钟漫画：即兴演讲（塑封）", "price": 39.8, "url": "https://img3m2.ddimg.cn/14/31/29649722-1_b_1699417622.jpg" },
        { "no": "9787545521283", "name": "儿童潜能开发全书：全脑开发", "price": 24.8, "url": "https://img3m1.ddimg.cn/34/8/1446631891-1_b_2.jpg" },
        { "no": "9787538652932", "name": "小拇指彩泥故事汇--识字弟子规3（彩绘注音版）", "price": 19.8, "url": "https://img3m8.ddimg.cn/0/17/11867440068-1_b_1730897327.jpg" },
        { "no": "9787555231004", "name": "（彩绘本）值得永久珍藏的经典童话--小红帽", "price": 29.8, "url": "https://img3m7.ddimg.cn/89/16/29293397-1_b_1706693751.jpg" },
        { "no": "9787538652888", "name": "小拇指彩泥故事汇--识字三字经6（彩绘注音版）", "price": 19.8, "url": "https://img3m3.ddimg.cn/19/7/11433450223-1_b_1.jpg" },
        { "no": "9787538652901", "name": "小拇指彩泥故事汇--识字三字经8（彩绘注音版）", "price": 19.8, "url": "https://img3m8.ddimg.cn/41/34/11886220508-1_b_1734087458.jpg" },
        { "no": "9787538652871", "name": "小拇指彩泥故事汇--识字三字经5（彩绘注音版）", "price": 19.8, "url": "https://img3m3.ddimg.cn/39/20/11770638303-1_b_1719691895.jpg" },
        { "no": "9787538652840", "name": "小拇指彩泥故事汇--识字三字经2（彩绘注音版）", "price": 19.8, "url": "https://img3m3.ddimg.cn/71/11/11719472363-1_b_1711099057.jpg" },
        { "no": "9787538652918", "name": "小拇指彩泥故事汇--识字弟子规1（彩绘注音版）", "price": 19.8, "url": "https://img3m8.ddimg.cn/79/34/11867440048-1_b_1730897326.jpg" },
        { "no": "9787538652833", "name": "小拇指彩泥故事汇--识字三字经1（彩绘注音版）", "price": 19.8, "url": "https://img3m3.ddimg.cn/50/35/11433449363-1_b_1.jpg" },
        { "no": "9787304069704", "name": "小伴龙开心学系列（全4册）*学乐N次写字母", "price": 25.8, "url": "https://img3m7.ddimg.cn/74/20/11123698187-1_b_1.jpg" },
        { "no": "9787304069407", "name": "小伴龙开心学系列（全4册）*学乐N次写快乐", "price": 25.8, "url": "https://img3m5.ddimg.cn/92/24/11191554785-1_b_1.jpg" },
        { "no": "9787304069391", "name": "小伴龙开心学系列（全4册）*学乐N次写玩转", "price": 25.8, "url": "https://img3m4.ddimg.cn/43/34/11022689644-1_b_1.jpg" },
        { "no": "9787304067793", "name": "小伴龙开心学系列（全4册）*学乐N次写学写", "price": 25.8, "url": "https://img3m5.ddimg.cn/49/19/11171525755-1_b_1.jpg" },
        { "no": "9787560340609", "name": "（绘本）奇幻星际（全8册不单发）--地球任务（美绘）", "price": 16, "url": "https://img3m6.ddimg.cn/69/13/11896136376-1_b_1735294415.jpg" },
        { "no": "9787560340609", "name": "（绘本）奇幻星际（全8册不单发）--金星任务（美绘）", "price": 16, "url": "https://img3m6.ddimg.cn/69/13/11896136376-1_b_1735294415.jpg" },
        { "no": "9787560340609", "name": "（绘本）奇幻星际（全8册不单发）--海王星任务（美绘）", "price": 16, "url": "https://img3m6.ddimg.cn/69/13/11896136376-1_b_1735294415.jpg" },
        { "no": "9787560340609", "name": "（绘本）奇幻星际（全8册不单发）--木星任务（美绘）", "price": 16, "url": "https://img3m6.ddimg.cn/69/13/11896136376-1_b_1735294415.jpg" },
        { "no": "9787560340609", "name": "（绘本）奇幻星际（全8册不单发）--天王星任务（美绘）", "price": 16, "url": "https://img3m6.ddimg.cn/69/13/11896136376-1_b_1735294415.jpg" },
        { "no": "9787560340609", "name": "（绘本）奇幻星际（全8册不单发）--土星任务（美绘）", "price": 16, "url": "https://img3m6.ddimg.cn/69/13/11896136376-1_b_1735294415.jpg" },
        { "no": "9787560340609", "name": "（绘本）奇幻星际（全8册不单发）--火星任务（美绘）", "price": 16, "url": "https://img3m6.ddimg.cn/69/13/11896136376-1_b_1735294415.jpg" },
        { "no": "9787560340609", "name": "（绘本）奇幻星际（全8册不单发）--水星任务（美绘）", "price": 16, "url": "https://img3m6.ddimg.cn/69/13/11896136376-1_b_1735294415.jpg" },
        { "no": "9787558510793", "name": "丰富民俗文化 百姓的嫁娶", "price": 36, "url": "https://img3m1.ddimg.cn/38/34/1901084861-1_b_1.jpg" },
        { "no": "9787558510809", "name": "丰富民俗文化 传统的祭典", "price": 36, "url": "https://img3m2.ddimg.cn/39/35/1901084862-1_b_1.jpg" },
        { "no": "9787558510700", "name": "丰富民俗文化 古老的佳节", "price": 36, "url": "https://img3m8.ddimg.cn/35/31/1901084858-1_b_1.jpg" },
        { "no": "9787558510717", "name": "丰富民俗文化 祭祀的清明", "price": 36, "url": "https://img3m3.ddimg.cn/30/26/1901084853-1_b_1.jpg" },
        { "no": "9787558510724", "name": "丰富民俗文化 浪漫的七夕", "price": 36, "url": "https://img3m5.ddimg.cn/32/28/1901084855-1_b_1.jpg" },
        { "no": "9787558510731", "name": "丰富民俗文化 民间的欢聚", "price": 36, "url": "https://img3m0.ddimg.cn/37/33/1901084860-1_b_1.jpg" },
        { "no": "9787558510748", "name": "丰富民俗文化 浓情的端午", "price": 36, "url": "https://img3m4.ddimg.cn/31/27/1901084854-1_b_1.jpg" },
        { "no": "9787558510755", "name": "丰富民俗文化 热闹的元宵", "price": 36, "url": "https://img3m2.ddimg.cn/29/25/1901084852-1_b_1.jpg" },
        { "no": "9787558510762", "name": "丰富民俗文化 踏秋的重阳", "price": 36, "url": "https://img3m7.ddimg.cn/34/30/1901084857-1_b_1.jpg" },
        { "no": "9787558510779", "name": "丰富民俗文化 团圆的中秋", "price": 36, "url": "https://img3m6.ddimg.cn/33/29/1901084856-1_b_1.jpg" },
        { "no": "9787558510786", "name": "丰富民俗文化 喜庆的春节", "price": 36, "url": "https://img3m1.ddimg.cn/28/24/1901084851-1_b_1.jpg" },
        { "no": "9787558510694", "name": "古老历史遗产 不朽的地标", "price": 36, "url": "https://img3m4.ddimg.cn/85/8/11862478174-1_b_1732630023.jpg" }
      ]

      //   获取数据
      getHomeGoods('sales').then(res => {
        goods.sales.list = res.goods.data;
      })
      getHomeGoods('recommend').then(res => {
        goods.recommend.list = res.goods.data;
      })
      getHomeGoods('new').then(res => {
        goods.new.list = res.goods.data;
      })

      // 创建BetterScroll对象--滚动
      bscroll = new BScroll(document.querySelector('.wrapper'), {
        probeType: 3, //0,1,2,3,3是只要在运动就触发scroll事件
        click: true,   //是否允许点击
        pullUpLoad: true, //下拉加载更多，默认为假
      });
      //使用触发滚动事件
      bscroll.on('scroll', (position) => {
        // console.log(banref.value.offsetHeight);
        // console.log(-position.y);
        // isShowBackTop.value = isTabFixed.value = (-position.y) > (banref.value.offsetHeight);

      })

      //上拉加载数据，触发事件-pullingUp
      bscroll.on("pullingUp", () => {
        // console.log('上拉加载更多-');
        const page = goods[currentType.value].page + 1;
        // if (page > 2) {
        //   return
        // }
        getHomeGoods(currentType.value, page).then(res => {
          goods[currentType.value].list.push(...res.goods.data.splice(0, 4));
          goods[currentType.value].page += 1;
        })
        //完成上拉，等数据请求完成，要将新数据展示出来
        bscroll.finishPullUp();

        //重新计算高度
        bscroll.refresh();
        // console.log("contentheight:"+document.querySelector('.content').clientHeight);
        // console.log("当前类型："+currentType.value+",当前页："+page);
      })

      // 数据变新
      nextTick(() => {
        //重新计算高度
        bscroll && bscroll.refresh();
      })


    })
    //触发从TabControl事件
    const tabClick = (index) => {
      let types = ['sales', 'new', 'recommend'];
      currentType.value = types[index];
    }
    // 监听 任何一个变量有变化
    watchEffect(() => {
      // 数据变新
      nextTick(() => {
        //重新计算高度
        bscroll && bscroll.refresh();
      })
    })


    // 返回顶部
    const bTop = () => {
      bscroll.scrollTo(0, 0, 300);
    }
    const goD = () => {
      Toast.fail('请打电话联系我们购买！');
    }

    return {
      recommends,
      tabClick,
      temid,
      goods,
      showGoods,
      isTabFixed,
      banref,
      isShowBackTop,
      bTop,
      banners,
      goD
    }
  }
}
// import NavBar from 'components/common/navbar/NavBar'
// // 挂载--生命周期
// // import {ref,onMounted} from 'vue';
// // import {getHomeAllData,getBanner} from 'network/home';
// export default {
//   name: 'Home',
//   // setup(){
//   //   const banner = ref([]);
//   //   onMounted(()=>{
//   //     getHomeAllData().then(res=>{
//   //       console.log(res);
//   //       banner.value = res.slides;
//   //     }).catch(err=>{

//   //     })
//   //   })
//   //   return{
//   //     banner
//   //   }
//   // },
//   components: {
//     NavBar
//   }
// }
</script>
<style scoped>
.banners img {
  width: 100%;
  height: 200px;
}
#home {
  height: 100vh;
  position: relative;
}
.wrapper {
  position: absolute;
  top: 45px;
  bottom: 50px;
  left: 0px;
  right: 0px;
  overflow: hidden;
}
</style>

<style scoped lang="scss">
.recommend {
  // width: 100%;
  display: flex;
  text-align: center;
  padding: 15px 0 30px;
  font-size: 10px;
  flex-wrap: wrap;
}
.recommend-item {
  // flex: 1;
  width: 33%;
  img {
    width: 80%;
    height: 80px;

    // margin-bottom: 10px;
  }
}
.text-ellipsis {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 限制为两行 */
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  white-space: normal;
}
</style>
<style>
html {
  font-size: 16px; /* 默认字体大小为16px */
}

body {
  font-size: 1rem; /* 默认字体大小为1rem，即16px */
}

h1 {
  font-size: 2rem; /* 标题字体大小为2rem，即32px */
}

p {
  font-size: 1rem; /* 段落字体大小为1rem，即16px */
}

/* 响应式字体大小调整 */
@media (max-width: 768px) {
  html {
    font-size: 14px; /* 在较小屏幕上减小字体大小 */
  }
}
</style>